import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import getDiscountLabel from '~/utils/getDiscountLabel';
import extractSubstrings from '~/utils/extractSubstrings';

interface IItem {
  sort: number;
  label?: string;
  bgColor: string;
  tooltip?: string;
  iconLink?: string;
  labelColor?: string;
  isAdditional?: boolean;
}
interface ISettings {
  isHideDiscountLabel?: boolean
}


const _getFirstPromotion = (product: IProduct) => {
  let fullCharacteristics = product?.characteristics || [];
  if (fullCharacteristics.length <= 0 && (product?.shortCharacteristics || []).length > 0) {
    fullCharacteristics = [
      {
        name: "",
        characteristics: product?.shortCharacteristics || []
      }
    ]
  }

  const skryvatLejblSoSkidkoj = getCharacteristicFromFull((fullCharacteristics || []), 'skryvat-lejbl-so-skidkoj');
  if (skryvatLejblSoSkidkoj?.values?.[0]?.slug === 'da') {
    return ''
  }

  const discountLabel = getCharacteristicFromFull((fullCharacteristics || []), 'discount-label');
  const discountDateLabel = getCharacteristicFromFull((fullCharacteristics || []), 'discount-label-date');
  const discountLabelTooltip = getCharacteristicFromFull((fullCharacteristics || []), 'lejbl-dlya-skidki-polnoe-opisanie');

  const labelValue = extractSubstrings(discountLabel?.values?.[0]?.value || '', '<p>', '</p>');
  const dateLabelValue = extractSubstrings(discountDateLabel?.values?.[0]?.value || '', '<p>', '</p>');

  if (!labelValue) {
    return {label: "",tooltip: ""}
  }
  return {
    label: [labelValue, dateLabelValue].filter((t: string) => !!t).join(' '),
    tooltip: discountLabelTooltip?.values?.[0]?.value || ''
  }
};
const getPromotionsProduct = (product: IProduct, settings?: ISettings) => {
  let _items: IItem[] = [];

  const firstPromotion: any = _getFirstPromotion(product);
  if (!!firstPromotion?.label && !settings?.isHideDiscountLabel) {
    _items.push({
      sort: 999999,
      label: firstPromotion?.label || '',
      tooltip: firstPromotion?.tooltip || '',
      bgColor: '#D3E6C6',
      isAdditional: false
    })
  }

  const _promotions = product?.promotions || [];
  _promotions.map((promotion: any) => {
    const isAdditional = Boolean(promotion?.dynamicFields?.is_additional);

    if (isAdditional && promotion?.icon) {
      _items.push({
        bgColor: '#EBEBEB',
        iconLink: promotion?.icon,
        tooltip: promotion?.description,
        sort: promotion?.dynamicFields?.sort || 0,
        isAdditional
      })
    }
    else if (
      Boolean(isAdditional && !promotion?.icon && promotion?.label) ||
      Boolean(!isAdditional && !firstPromotion?.label && promotion?.label)
    ) {
      _items.push({
        label: promotion?.label,
        sort: promotion?.dynamicFields?.sort || 1,
        bgColor: promotion?.dynamicFields?.label_color,
        tooltip: promotion?.description,
        isAdditional
      })
    }
  });

  _items = _items.sort((a: IItem, b: IItem) => {
    if (a.sort < b.sort) {
      return 1
    }
    if (a.sort > b.sort) {
      return -1
    }
    return 0
  });

  const countNotAdditional: number = _items.filter((t) => !t.isAdditional).length;
  if (!settings?.isHideDiscountLabel && countNotAdditional <= 0 && getDiscountLabel(product)?.label) {
    _items.unshift({
      label: getDiscountLabel(product)?.label || '',
      sort: 0,
      bgColor: ''
    });
  }

  return _items
};
const getPromotionsProductCard = (product: IProduct) => {
  let _list = getPromotionsProduct(product, { isHideDiscountLabel: true });
  return _list
};

export default getPromotionsProduct
export {
  getPromotionsProductCard
}
